export default "__VITE_ASSET__MpdzQgeT__"